<div class="content-wrapper">
  <div class="container">
    <div class="success-card">
      <div class="success-header">
        <i class="material-icons">
          {{ documentStatus === 'error' ? 'error_outline' :
          documentStatus === 'cancelled' ? 'cancel_presentation' :
          documentStatus === 'ready' ? 'check_circle_outline' :
          'hourglass_empty' }}
        </i>
        <h1>
          {{
          (
          isFreePurchase ? 'PAYMENT.DOCUMENT_FREE' :
          documentStatus === 'error' ? 'PAYMENT.PAYMENT_ERROR' :
          documentStatus === 'cancelled' ? 'PAYMENT.PAYMENT_CANCELLED' :
          'PAYMENT.PAYMENT_SUCCESS'
          ) | translate
          }}
        </h1>
      </div>

      <div>
        <p *ngIf="documentStatus !== 'error' && documentStatus !== 'cancelled'">
          {{ (isFreePurchase
          ? 'PAYMENT.DOCUMENT_READY_1'
          : 'PAYMENT.DOCUMENT_READY_2'
          ) | translate
          }}
        </p>

        <div class="document-info" *ngIf="payment">
          <div class="info-row">
            <strong>{{ 'PAYMENT.DOCUMENT' | translate }}:</strong>
            <span>{{ (payment.documentType || 'PAYMENT.DOCUMENT_LOADING') | translate }}</span>
          </div>
          <div class="info-row">
            <strong>{{ 'PAYMENT.DOCUMENT_FORMAT' | translate }}:</strong>
            <span>{{ (payment.documentFormat || 'PAYMENT.DOCUMENT_LOADING') | translate }}</span>
          </div>
          <div class="info-row" *ngIf="!isFreePurchase">
            <strong>{{ 'PAYMENT.DOCUMENT_PRICE' | translate }}:</strong>
            <span>{{ (payment.amount ? (payment.amount + ' ' + payment.currency) : 'PAYMENT.DOCUMENT_LOADING' |
              translate )}}</span>
          </div>
          <div class="info-row">
            <strong>{{ 'PAYMENT.DOCUMENT_STATUS' | translate }}:</strong>
            <span class="status" [ngClass]="{
              'ready': documentStatus === 'ready',
              'generating': documentStatus === 'generating' || documentStatus === 'checking',
              'error': documentStatus === 'error' || documentStatus === 'cancelled'
            }">
              {{ (documentStatus === 'ready' ? 'PAYMENT.STATUS_READY' :
              documentStatus === 'generating' ? 'PAYMENT.STATUS_GENERATING' :
              documentStatus === 'checking' ? 'PAYMENT.STATUS_CHECKING' :
              documentStatus === 'error' ? 'PAYMENT.STATUS_ERROR' :
              documentStatus === 'cancelled' ? 'PAYMENT.STATUS_CANCELLED' :
              'PAYMENT.STATUS_WAITING'
              ) | translate
              }}
            </span>
          </div>
        </div>

        <div *ngIf="documentStatus === 'generating'" class="generating-message">
          <mat-spinner diameter="30"></mat-spinner>
          <p>{{ 'PAYMENT.ACTION_GENERATING' | translate }}</p>
        </div>

        <div *ngIf="documentStatus === 'checking'" class="generating-message">
          <mat-spinner diameter="30"></mat-spinner>
          <p>{{ 'PAYMENT.ACTION_CHECKING' | translate }}</p>
        </div>

        <div *ngIf="isDownloading" class="generating-message">
          <mat-spinner diameter="30"></mat-spinner>
          <p>{{ 'PAYMENT.ACTION_DOWNLOADING' | translate }}</p>
        </div>

        <div *ngIf="downloadError" class="error-message">
          <i class="material-icons">error_outline</i>
          <p>{{ downloadError }}</p>
          <div class="button-container">
            <button mat-raised-button color="warn" (click)="retryDocumentCheck()">
              <i class="material-icons">refresh</i>
              {{ 'PAYMENT.RELOAD_DOCUMENT' | translate }}
            </button>
          </div>
        </div>

        <div class="buttons">
          <button mat-raised-button color="primary" (click)="onDownloadDocument()"
            [disabled]="documentStatus === 'error' || documentStatus === 'cancelled' || isDownloading">
            <i class="material-icons">file_download</i>
            {{ 'PAYMENT.DOWNLOAD_DOCUMENT' | translate }}
          </button>

          <button mat-stroked-button (click)="goToDocuments()">
            <i class="material-icons">arrow_back</i>
            {{ 'PAYMENT.BACK_TO_DOCUMENTS' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>